/** Formats a calendar date without converting it to UTC. */
export function formatLocalDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

/** Parses a database date-only value as a local calendar date. */
export function parseLocalDate(value: string): Date {
  const [year, month, day] = value.split('T')[0].split('-').map(Number);

  return new Date(year, month - 1, day);
}
